<div class="modal-header">
	<h5 class="modal-title">Please provide a brief reason why you are deleting this record.</h5>
	<button 
		type="button" 
		class="close" 
		aria-label="Close" 
		(click)="activeModal.dismiss()"
	>
		<span aria-hidden="true">&times;</span>
	</button>
</div>

<div class="modal-body">
	@if (noDeleteMessage) { <div class="text-danger">*A comment is required</div> }
	<textarea 
        #deleteCommentInput
		class="w-100 form-control" 
		[(ngModel)]="deleteComment" 
		maxlength="150"
	></textarea>
	<div>Characters Left: {{ 150 - deleteComment?.length }}</div>
</div>

<div class="modal-footer">
	<button 
		type="button" 
		class="btn btn-cancel btn-lg" 
		(click)="activeModal.dismiss()"
	>Cancel</button>
	<button 
		type="button" 
		class="btn btn-save btn-lg" 
		(click)="confirmDelete()"
	>Continue</button>
</div>